/**
 * Gets domain from url of any type
 * @param {String} url - URL to pop domain from
 * @returns {String} - domain zone
 */
export default function getDomainZone(lang) {
  return lang === "ru" ? "ru" : "com";
}
